import { For, JSX } from "solid-js";
import { RandomEmojiFaces } from "~/components/brand_l2/trust_marker_happy_users";

/**
 * Trust Markers section with stats and Hubble Promise
 * Matches Figma design: 606-31588
 */

const promises = [
  {
    text: "Instant gift card e-delivery",
    icon: "lightning_trust_marker",
  },
  {
    text: "Guaranteed savings",
    icon: "piggy_bank_trust_marker",
  },
  {
    text: "Safe & secure payment",
    icon: "shield_check_trust_marker",
  },
  {
    text: "Zero Hassle support",
    icon: "headset_trust_marker",
  },
];

export function TrustMarkersSection(): JSX.Element {
  return (
    <div class=" w-full rounded-2xl border border-stroke-1 bg-background-normal-primary p-1">
      {/* Inner card with gradient background */}
      <div class="telescope-light-theme flex w-full flex-col gap-4 rounded-[13px] border border-stroke-1 bg-gradient-to-r from-[#fffaee] to-[#ffffff]">
        {/* Stats Section */}
        <div class="flex w-full  flex-col-reverse items-start justify-between gap-3 px-4 pt-4 lg:flex-row">
          {/* Stats */}
          <div class="flex items-center gap-10">
            {/* Happy Users Stat */}
            <div class="flex flex-col items-start justify-center">
              <p class="text-title-4-semi-bold text-text-normal-primary">5L+</p>
              <p class="text-label-regular text-text-normal-primary">
                Happy Hubble users
              </p>
            </div>

            {/* Savings Stat */}
            <div class="flex flex-col items-start justify-center">
              <p class="text-title-4-semi-bold text-text-normal-primary">
                ₹10Cr
              </p>
              <p class="text-label-regular text-text-normal-primary">
                Saved till date with gift cards
              </p>
            </div>
          </div>

          <RandomEmojiFaces />
        </div>

        {/* Divider */}
        <div class="h-px w-full bg-stroke-1" />

        {/* Hubble Promise Section */}
        <div class="flex w-full flex-col gap-3 px-4 pb-4">
          {/* Promise Label */}
          <p class="text-label-semi-bold text-[#9f784b]">HUBBLE PROMISE</p>

          <div class="grid grid-cols-1 gap-2 lg:grid-cols-2 lg:gap-x-6 lg:gap-y-2">
            <For each={promises}>
              {(promise) => (
                <div class="inline-flex flex-row items-center gap-1">
                  <img
                    src={`https://assets.myhubble.money/web-assets/${promise.icon}.svg`}
                    alt={promise.text}
                  />
                  <div class="text-mediumBold text-basePrimaryDark">
                    {promise.text}
                  </div>
                </div>
              )}
            </For>
          </div>
        </div>
      </div>
    </div>
  );
}
